// extracted by mini-css-extract-plugin
export default {"advertCardPhoto":"c-a_it","advertCardPhoto__image":"c-a_iu"};